export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=60dab4dcc527ee4d1dfbc2e7ad719e2333e9a32f98&name=fetchTypeahead!'